export * from "./remote-config";
